import styled from "styled-components";

export const OverlayContainer = styled.div<{ $show: boolean; $zIndex: number }>`
  visibility: ${({ $show }) => ($show ? "visible" : "hidden")};
  position: fixed;
  width: 100%;
  height: 100%;
  transition: background 0.3s ease-in-out;
  background: ${({ $show }) => ($show ? "rgb(0 0 0 / 0.5)" : "rgb(0 0 0 / 0)")};
  z-index: ${({ $zIndex }) => $zIndex};
  min-height: 100vh;
  top: 0;
`;

